export default __webpack_public_path__ + "static/char-v-46-e5ebad23e0324ab867e80c2252da9a08.webp";